import { useSceneEntities } from "@/stores/SceneEntities";

export function useAssetFaucett17464iSideLeft(payload, viewport) {
    const sceneEntities = useSceneEntities();

 
let t17494i_sidebarleft = sceneEntities.getUIData("t17494i_sidebarleft");
let t17494i = sceneEntities.getUIData("t17494i");

    let t17464i_head_slide_left = sceneEntities.configuratorView.viewportComponent.getViewportAsset("t17464i_head_slide_left");
    t17464i_head_slide_left.disabled = payload.disabled;
    t17464i_head_slide_left.enabled = payload.enabled;
    
    viewport.setEnabled(t17464i_head_slide_left);

    let head_slide_hose_left = sceneEntities.configuratorView.viewportComponent.getViewportAsset("head_slide_hose_left");
    head_slide_hose_left.disabled = payload.disabled;
    head_slide_hose_left.enabled = payload.enabled || (t17494i_sidebarleft.enabled && t17494i.enabled);
    viewport.setEnabled(head_slide_hose_left);

  

}